export default "__VITE_ASSET__w0Vay0OW__"